import CleanEnergy from "@/res/images/clean-energy-council.png";
import SmartEnergy from "@/res//images/smart-energy-council.png";
import FacebookIcon from "@/components/icons/FacebookIcon";
import TwitterIcon from "@/components/icons/TwitterIcon";
import InstagramIcon from "@/components/icons/InstagramIcon";
import Logo from "@/components/icons/Logo";
import { Link } from "react-router";

const socials = [
  {
    name: "Facebook",
    icon: FacebookIcon,
    href: "https://www.facebook.com/solarcloudau/",
  },
  { name: "Twitter", icon: TwitterIcon, href: "https://x.com/SolarCloudau/" },
  {
    name: "Instagram",
    icon: InstagramIcon,
    href: "https://www.instagram.com/solarcloud.com.au/",
  },
];

type LinkType = {
  name: string;
  href: string;
};
const links: LinkType[][] = [
  // [
  //   { name: "Your guarantee", href: "/#" },
  //   { name: "Your money", href: "/#" },
  // ],
  // [
  //   { name: "Indicative return", href: "/#" },
  //   { name: "Replacement Product Disclosure Statement", href: "/#" },
  // ],
  // [
  //   { name: "SolarCloud Constitution", href: "/#" },
  //   { name: "Management agreement", href: "/#" },
  // ],
];

export default function Footer({
  className,
  mainLink,
}: {
  className?: string;
  mainLink?: string;
}) {
  return (
    <footer className={className}>
      <section className="border-t border-brand-neutral-700">
        <div className="mx-auto max-w-screen-xl space-y-8 px-4 py-16 sm:px-6 lg:space-y-16 lg:px-8">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div className="flex flex-col">
              <Logo className="h-16 w-full" mainLink={mainLink} />

              <ul className="mt-2 flex gap-6">
                {socials.map((social) => {
                  const Icon = social.icon;
                  return (
                    <li key={social.name}>
                      <a
                        href={social.href}
                        rel="noreferrer"
                        target="_blank"
                        className="text-brand-neutral-500 transition hover:opacity-75"
                      >
                        <Icon className="size-6" />
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-3 lg:mt-4">
              {links.map((linkGroup, index) => (
                <ul key={index} className="space-y-4 text-sm">
                  {linkGroup.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.href}
                        className="text-brand-neutral-500 transition hover:text-brand-neutral-500 hover:underline"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="border-t border-brand-neutral-700">
        <div className="mx-auto max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8 flex flex-col md:flex-row">
          <p className="text-sm text-brand-neutral-500 md:w-3/4 flex flex-col gap-4">
            <span>
              This is an indicative return only, and not a guaranteed or minimum
              return. The return to a panel investor in the SolarCloud scheme is
              from a pool of solar panels owned by multiple investors, which are
              likely to be located on multiple sites. The return available from
              each site is affected by weather, climate, orientation, power sale
              price achieved and the other risks described in the Product
              Disclosure Statement (PDS). The rate of return to an investor is
              not set to any one site – it is intended that the returns from
              each site will be pooled to minimise an investor’s exposure to any
              one site. The Internal Rate of Return (IRR) calculated here is
              based on a 25 year term, 29.76 kW system purchased at $1.82 per
              Watt, with system output of 134 kWh per day (based on Helioscope
              yield calculations for Jinko 320 watt panels with a Fronius
              inverter in Mudgee NSW, oriented north with 30 degrees tilt), 100%
              of the system output sold at a base price 11.2c/kWh with price
              escalation of 2% per annum, 95% availability of system, panel
              degradation of 0.6% per annum, and with management, operation and
              maintenance costs of 20% gross revenue. The actual
              characteristics, costs and returns of each site will differ from
              this, but SolarCloud believes this is a reasonable indicative
              forecast of the potential returns from the pool based on currently
              available information.{" "}
            </span>
            <span>
              SolarCloud operates an Australian Securities and Investment
              Commission (ASIC) Registered Scheme (ARSN: 612098110) allowing you
              to invest in solar panels for a financial return. SolarCloud is a
              member of the Australian Solar Council and all our installers are
              Clean Energy Council Members. All investments must be made on the
              form of Application form included in the Replacement Product
              Disclosure Statement, a copy of which is available here. All
              prices shown are in AUD (Australian Dollars) unless stated
              otherwise.
            </span>
          </p>
          <ul className="mt-8 md:mt-0 flex flex-row md:flex-col justify-around md:justify-between w-full md:w-1/4 items-center">
            <li>
              <img
                alt="Clean Energy Council"
                src={CleanEnergy}
                width={127}
                height={62}
              />
            </li>
            <li>
              <img
                alt="Smart Energy Council"
                src={SmartEnergy}
                width={127}
                height={62}
              />
            </li>
          </ul>
        </div>
      </section>
      <section className="pb-4">
        <p className="text-xs text-gray-500 flex flex-col sm:flex-row gap-4 divide-y-brand-neutral-700 items-center justify-center">
          <span>&copy; SolarCloud 2020</span>
          <span className="hidden md:block">|</span>
          <span>ABN 45 164 838 288</span>
          <span className="hidden md:block">|</span>
          <span>ARSN 612 098 110</span>
          <span className="hidden md:block">|</span>
          <span>Patent No 2015101110</span>
        </p>
      </section>
    </footer>
  );
}
